import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fromJS, List, Map } from 'immutable';

import { MAPS_VENDORS, PANORAMAS_VENDORS } from '../../consts';
import api from '../../apiSingleton';
import { loadInfrastructure } from '../../app/Maps/actions';
import getDictionary from '../../utils/dictionaries';

import { DGisLayer, YandexLayer } from './Layers';
import YandexPanorama from './Panoramas/YandexPanorama';
import MapsControls from './Controls/MapsControls';
import Announcement from '../../classes/announcement/announcement';
import GeoObject from '../../classes/geo/geoObject';

class Maps extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      view: props.isSuburb ? MAPS_VENDORS.yandex : MAPS_VENDORS.dgis,
      category: [],
      listSimilar: new List(),
      listInfrastructure: new Map(), // загруженная инфраструктура
      selectInfrastructureId: ''      // выбранные id
    };

    this.realtyId = props.realtyId;
    this.realtyType = props.realtyType;
    this.dealType = props.dealType;

    this.lat = props.lat;
    this.lon = props.lon;
    this.isSuburb = props.isSuburb;
    this.filter = Object.assign({}, {
      fields: 'id,objectTypeId,location,squareTotal,uri,price,services,floor,floorTotal',
      expand: 'mainPhoto',
      'per-page': 100
    }, props.similarFilter);

    this.mapsLayers = {
      [MAPS_VENDORS.dgis]: DGisLayer,
      [MAPS_VENDORS.yandex]: YandexLayer
    };

    this.panoramaLayers = {
      [PANORAMAS_VENDORS.yandex]: YandexPanorama
    };

    this.onChangeView = this.onChangeView.bind(this);
    this.mapsLayerReady = this.mapsLayerReady.bind(this);

    this.props.dispatch(loadInfrastructure(this.realtyId, this.lon, this.lat));
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if (!this.state.listInfrastructure.equals(nextProps.infrastructure)) {
      this.setState({
        listInfrastructure: nextProps.infrastructure
      });
    }
  }

  /**
   * Переключает вид
   * @param view
   */
  onChangeView (view) {
    this.setState({view});
  }

  /**
   * Загружает похожие объекты
   */
  fetchSimilarAlternatives () {
    api.announcement.fetchAnnouncement(this.dealType, this.realtyType, this.filter)
      .then((data) => {
        const items = data.items
          .filter(item => {
            return item.location.lonLat &&
              parseFloat(item.location.lonLat[0]) &&
              parseFloat(item.location.lonLat[1]);
          })
          .map(item => this.makeSimilarItem(item));

        this.setState({listSimilar: new List(items)});
      })
      .catch((err) => console.log('---fetchSimilarAlternatives', err.message));
  }

  /**
   * Преобразовывает данные из api в объект для балунов
   * @param item
   */
  makeSimilarItem (item) {
    const data = new Announcement(fromJS(item), this.props.dictionary);

    return GeoObject.makePopupItem(data);
  }

  /**
   * Срабатывает картой, когда она инициализированна
   * @param mapState
   */
  mapsLayerReady (mapState) {
    this.filter.bounds = [
      mapState.bounds.southwest_lng,
      mapState.bounds.southwest_lat,
      mapState.bounds.northeast_lng,
      mapState.bounds.northeast_lat
    ].join(',');

    if (this.state.listSimilar.isEmpty()) {
      this.fetchSimilarAlternatives();
    }
  }

  isMap () {
    return !!(this.mapsLayers[this.state.view] || null);
  }

  isPanorama () {
    return !!(this.panoramaLayers[this.state.view] || null);
  }

  renderMaps () {
    const Maps = this.mapsLayers[this.state.view] || null;

    return Maps && <Maps
      zoom={16}
      lat={this.lat}
      lon={this.lon}
      onLoad={this.mapsLayerReady}
      similar={this.state.listSimilar}
      listInfrastructure={this.state.listInfrastructure}
      selectInfrastructureId={this.state.selectInfrastructureId}
    />;
  }

  renderPanorama () {
    const Panorama = this.panoramaLayers[this.state.view] || null;

    return Panorama && <Panorama lat={this.lat} lon={this.lon} />;
  }

  renderLegend () {
    return (
      <ul className='list-hor list-inline maps-legend'>
        <li><div className='maps-placemark maps-main-placemark' /></li>
        <li>- это объявление</li>
        <li><div className='maps-placemark' /></li>
        <li>- похожие объявления</li>
      </ul>
    );
  }

  render () {
    const disablePanorama = this.isSuburb;

    return (
      <div className='maps-container'>
        <MapsControls
          activeView={this.state.view}
          disablePanorama={disablePanorama}
          onChangeView={this.onChangeView}

          disableInfrastructure={this.isPanorama()}
          listInfrastructure={this.state.listInfrastructure}
          selectInfrastructure={this.state.selectInfrastructureId}
          onChangeInfrastructure={(_, selectInfrastructureId) => this.setState({selectInfrastructureId})}
        />

        {this.isMap() && this.renderLegend()}

        {this.renderMaps()}

        {this.renderPanorama()}
      </div>
    );
  }
}

Maps.propTypes = {
  dictionary: PropTypes.object.isRequired,
  infrastructure: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,

  realtyId: PropTypes.number.isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,
  lat: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  lon: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  similarFilter: PropTypes.object.isRequired,
  isSuburb: PropTypes.bool
};

Maps.defaultProps = {
  isSuburb: false
};

function mapStateToProps (state) {
  return {
    dictionary: getDictionary(state.get('dictionaries')),
    infrastructure: state.getIn(['maps', 'infrastructure', 'data'])
  };
}

export default connect(mapStateToProps)(Maps);



// WEBPACK FOOTER //
// ./src/ui/Maps/Maps.jsx